import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  methods: {
    checkCheckedByAllParticipants(check) {
      // Checkin ids indicate the number of checkins by participants.
      return _.isEqual(
        check.checkinIds.length,
        this.participantsNumberByCheckList(
          this.storeLedgerId || this.ledgerId,
          check.checkListId
        )
      )
    },
  },

  computed: {
    ...mapGetters(['participantsNumberByCheckList']),
  },
}
